export default __webpack_public_path__ + "static/media/sticker-u.d959fbba.png";